
<template>
  <div>
    <div class="ipub-h1 mar-b-12">Manuscript No. {{detail.code}}</div>
    <div class="ipub-block mar-b-30">
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Article Type</strong>
        <span class="ipub-block__font">{{detail.type && detail.type.name||'--'}}</span>
      </div>
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Journal</strong>
        <span class="ipub-block__font">{{detail.journal&&detail.journal.fullName||'--'}}</span>
      </div>
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Article Title</strong>
        <span class="ipub-block__font">{{detail.title||'--'}}</span>
      </div>
      <div class="flex ipub-p2">
        <strong class="ipub-block__span">Abstract</strong>
        <div class="ipub-block__font"
             v-html="detail.summary && detail.summary.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')||'--'"></div>
      </div>
    </div>
    <div class="mar-b-16 ipubw-p2">If you accept the invitation, we would appreciate receiving your comments by <strong>{{detail.reviewDueDay}}</strong> days</div>
    <div ref="turnstile"></div>
    <div v-if="turnstileError"
         class="key-color ipub-p2 mar-b-12">{{turnstileError}}</div>
    <div>
      <ipub-button plain
                   type="primary"
                   :disabled="submitLoading"
                   @click="cancel">Cancel</ipub-button>
      <ipub-button class="mar-b-20"
                   type="primary"
                   :loading="submitLoading"
                   @click="submit">Accept to review this manuscript</ipub-button>
    </div>

  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
.part {
  background: $content_color;
  padding: 24px 36px 36px;
}
</style>
